const getCookieValue = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const prefix = `${name}=`;
  const match = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(prefix));

  return match ? decodeURIComponent(match.substring(prefix.length)) : null;
};

export const isFeatureEnabled = (cookieName: string): boolean => {
  return getCookieValue(cookieName) === '1';
};

export const featureToggleService = {
  isFeatureEnabled,
};
